import { DatePicker, ConfigProvider } from 'antd'
import locale from 'antd/locale/ru_RU'
import dayjs from 'dayjs'
import { CSSProperties } from 'react'

dayjs.locale('ru-ru')

interface IProps {
  selectedTs: number // unix ts
  onChange: (ts: number, name?: string) => void
  name?: string

  /** Размер компонента */
  size?: 'large' | 'middle'

  withTime?: boolean
  disabled?: boolean
  allowSelectInFuture?: boolean
  style?: CSSProperties
  format?: string
}

const AntDatePicker = (props: IProps) => {
  return (
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          colorPrimary: '#722ed1',
          colorPrimaryHover: '#9254de',
          colorPrimaryActive: '#531dab',
          colorPrimaryBg: '#f9f0ff',
        },
      }}
    >
      <DatePicker
        size={props.size ?? 'middle'}
        style={props.style}
        value={props.selectedTs ? dayjs(props.selectedTs) : undefined}
        disabled={props.disabled}
        format={props.format || 'DD.MM.YYYY'}
        disabledDate={props.allowSelectInFuture ? undefined : disabledDate}
        showTime={props.withTime}
        onOk={(val) => val && props.onChange(val.unix() * 1000, props.name)}
        onChange={(val) => val && props.onChange(val.unix() * 1000, props.name)}
      />
    </ConfigProvider>
  )
}

const disabledDate = (date, info) => {
  if (info.type === 'date') {
    return date.isAfter(new Date())
  }
}

export default AntDatePicker
